export const mimeTypeConvertor = (extension ) => {
    const mimeDictionary = {
        pdf : 'application/pdf',
        zip:'application/zip' ,
        doc:'application/msword' ,
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xlsx:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ,
        txt: 'text/plain' ,
        mp4: 'video/mp4',
        xml:'application/xml',
        jpg:'image/jpeg',
        jpeg:'image/jpeg',
        png:'image/png',
        avif:'image/avif',
        bmp:'image/bmp',
        webp:'image/webp',
    };
    return  extension.split('.').map(ext => mimeDictionary[ext.replace(',','').trim()] ?? ext);
}
